/****************************************************
 * Module Name:  markStoneReceivedModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Constants from "../../utility/constants";
import { Box, TextField, Button } from "@mui/material";
import TabMenuSnackbar from "../common/tabMenuSnackbar";
import logo from '../../images/pansuriya.jpg';
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { LoadingButton } from "@mui/lab";

function MarkStoneReceivedModal({
  show,
  setShow,
  handleValidation,
  handleSave,
  stoneId,
  sourceData,
  loading
}) {
  const [remark, setRemark] = useState("");
  const [showError, setShowError] = useState(false);

  const prepareStoneData = () => {
    let stoneDataArray = [];
    sourceData.map((iData) => {
      if (stoneId.includes(iData.stoneid)) {
        let obj = {
          stoneid: iData.stoneid,
          oldstatus: iData.stonelabdetailstatus,
          newstatus: "STONE_RECEIVED",
        };
        stoneDataArray.push(obj);
      }
      return stoneDataArray;
    });
    return stoneDataArray;
  };

  const saveHandler = () => {
    let data = {
      userid: Constants.loggedInUser.id,
      remark: remark,
      stones: prepareStoneData(),
    };
    if (handleSave) {
      if (handleValidation) {
        if (handleValidation(data)) {
          //need to add labId here and in the parent component if need for validation
          handleSave(data);
        } else {
          setShowError(true);
        }
      } else {
        handleSave(data);
      }
    }
  };

  const closeErrorDialog = () => {
    setShowError(false);
  };

  const handleClose = () => {
    setShow(false);
  };
  return (
    <div>
      <TabMenuSnackbar
        show={showError}
        message={
          <Box>
            mark stone received validation Failed
            <br /> Please enter correct data
          </Box>
        }
        variant={"error"}
        autoHide={false}
        handleClose={closeErrorDialog}
        title="Validation Failure"
      />
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={true}
        size="lg"
        centered
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <img
              src={logo}
              height="40pt"
              width="40pt"
              alt={Constants.COMPANY_SITE}
            />
            &nbsp;&nbsp;Mark Stone Received
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Box sx={{ display: "flex", gap: "20px", mt: 2 }}>
            <Form.Label className="mt-2">Remark</Form.Label>
            <TextField
              id="outlined-multiline-static"
              label="Remark"
              multiline
              fullWidth
              rows={4}
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <LoadingButton
            variant="contained"
            onClick={saveHandler}
            type="Submit"
            sx={{ mr: 3 }}
            loading={loading}
            startIcon={<SendRoundedIcon size="large" />}
            loadingPosition="start"
          >
            Mark
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            onClick={handleClose}
            sx={{ mr: 2 }}
            disabled={loading}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default MarkStoneReceivedModal;
